module.exports = __webpack_public_path__ + "img/no-notes.e3f4c5f7.svg";